import { useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Grid } from '@mui/material'

import Select from './Select'
import GridHeader from './GridHeader'
import { getCategorie } from '../hooks/selection-get-functions'
import { sortCategorie, sortNumeriGara } from '../hooks/sort-functions'
import {
  useGetCalendariQuery,
  useGetCampionatiQuery,
  useGetCategorieQuery,
  useGetIscrizioniQuery,
} from '../hooks/api-slice'
import { setDistinta, setDistintaField } from '../container/distinte'

const DistintaGaraSelection = ({ readOnly }) => {
  const { codiceUtente } = useSelector(state => state.home.infoUtente)

  const dispatch = useDispatch()

  const iDispatch = useCallback(
    (field, value) => dispatch(setDistintaField({ field, value })),
    [dispatch],
  )

  const [selCampionato, setSelCampionato] = useState()
  const [selCampionati, setSelCampionati] = useState()
  const [selCategoria, setSelCategoria] = useState()
  const [selCategorie, setSelCategorie] = useState()
  const [selSquadra, setSelSquadra] = useState()
  const [selSquadre, setSelSquadre] = useState()
  const [selNumeroGara, setSelNumeroGara] = useState()
  const [selNumeroGare, setSelNumeroGare] = useState()

  const { data: campionati } = useGetCampionatiQuery()
  const { data: categorie } = useGetCategorieQuery()

  const { data: availableGare, isFetching: isFetchingA } = useGetCalendariQuery(
    { selectedCampionato: selCampionato, codiceUtente, tipologia: 'distinta' },
    { skip: !(selCampionato && codiceUtente), refetchOnMountOrArgChange: true },
  )

  const { data: iscrizioniLight } = useGetIscrizioniQuery(
    { campionato: selCampionato, iFilter: 'light' },
    { skip: !selCampionato },
  )

  useEffect(() => {
    setSelCampionati(
      campionati?.filter(c => !!c.calendariPubblicati && !c.campionatoChiuso),
    )
  }, [campionati])

  useEffect(() => {
    setSelCategorie(
      categorie
        ?.filter(c =>
          getCategorie(
            availableGare?.filter(g => g.codiceCampionato === selCampionato),
          )?.includes(c.categoria),
        )
        ?.sort((a, b) => sortCategorie(a.categoria, b.categoria)),
    )
  }, [availableGare, categorie, selCampionato])

  useEffect(() => {
    setSelSquadre(
      iscrizioniLight?.filter(
        i =>
          String(i.codiceSocieta) === codiceUtente &&
          i.categoria === selCategoria &&
          (availableGare?.map(a => a.squadraCasaID)?.includes(i._id) ||
            availableGare?.map(a => a.squadraTrasfertaID)?.includes(i._id)),
      ),
    )
  }, [availableGare, codiceUtente, iscrizioniLight, selCategoria])

  useEffect(() => {
    setSelNumeroGare(
      availableGare
        ?.filter(
          a =>
            a.squadraCasaID === selSquadra ||
            a.squadraTrasfertaID === selSquadra,
        )
        ?.map(a => a.numeroGara)
        ?.sort(sortNumeriGara),
    )
  }, [availableGare, selSquadra])

  useEffect(() => {
    dispatch(setDistinta({ idSquadra: selSquadra }))
  }, [dispatch, selSquadra])

  useEffect(() => {
    const idGara = availableGare?.find(a => a.numeroGara === selNumeroGara)?._id
    iDispatch('idGara', idGara)
  }, [availableGare, iDispatch, selNumeroGara])

  useEffect(() => {
    setSelCategoria()
  }, [selCampionato])

  useEffect(() => {
    setSelSquadra()
  }, [selCategoria])

  useEffect(() => {
    setSelNumeroGara()
  }, [selSquadra])

  return (
    <Grid container paddingY={2} spacing={2} sx={{ width: '100%' }}>
      <Grid size={{ xs: 12, md: 3 }}>
        <Select
          id='campionato'
          label='Campionato'
          value={selCampionato}
          options={selCampionati?.map(c => c.codice)}
          optionLabels={selCampionati?.map(c => c.nome)}
          onChange={setSelCampionato}
          errorFunc={() => !selCampionato}
          disabled={!selCampionati?.length}
          readOnly={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <Select
          id='categoria'
          label='Categoria'
          value={selCategoria}
          options={selCategorie?.map(c => c.categoria)}
          optionLabels={selCategorie?.map(c => c.nome)}
          onChange={setSelCategoria}
          errorFunc={() => !selCategoria}
          disabled={!selCategorie?.length}
          readOnly={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Select
          id='squadra'
          label='Squadra'
          value={selSquadra}
          options={selSquadre?.map(s => s._id)}
          optionLabels={selSquadre?.map(s => s.nomeSquadra)}
          onChange={setSelSquadra}
          errorFunc={() => !selSquadra}
          disabled={!selSquadre?.length}
          readOnly={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 2 }}>
        <Select
          id='numero-gara'
          label='Gara'
          value={selNumeroGara}
          options={selNumeroGare}
          onChange={setSelNumeroGara}
          errorFunc={() => !selNumeroGara}
          disabled={!selNumeroGare?.length}
          readOnly={readOnly}
        />
      </Grid>
      {selCampionato && !selNumeroGara && !isFetchingA && (
        <GridHeader
          text={
            (availableGare?.length > 0 && 'Selezionare una gara.') ||
            'Nessuna gara idonea in questo campionato.'
          }
        />
      )}
    </Grid>
  )
}

export default DistintaGaraSelection
